// extracted by css-extract-rspack-plugin
export default {"ingressButton":"ingressButton-hwh9xr"};